import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../model/store';
import { userSlice } from '../model/userSlice';
import { useRhAuth } from '../contexts/RhAuthContext';

export const useUserRoles = () => {
  const roles = useSelector((state: RootState) => state.user.profile?.roles);
  const [loading, setLoading] = useState(_.isEmpty(roles));
  const dispatch = useDispatch();
  const { user, getIdTokenClaims } = useRhAuth();

  useEffect(() => {
    (async () => {
      const claims = getIdTokenClaims();

      let audience = process.env.REACT_APP_AUTH0_AUDIENCE || '';
      if (!audience.endsWith('/api')) {
        if (audience.endsWith('/')) audience = audience.slice(0, -1);
        audience = audience + '/api';
      }

      const claimKey = `${audience}/roles`;
      const extractedRoles = claims?.[claimKey] || claims?.roles || [];

      dispatch(
        userSlice.actions.receivedUser({
          user: { roles: extractedRoles },
        })
      );

      if (loading) setLoading(false);
    })();
  }, [dispatch, getIdTokenClaims, loading, user]);

  return { loading, roles };
};
